import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CollegeInfoService} from '../../services/college-info.service';
import {LangChange} from '../../../../lang-change';
import {Language} from '../../../../common/models/language';
import {Utils} from '../../../../common/services/Utils';
import {EnrollApplicationDialogComponent} from "../enroll-enter/enroll-application-dialog/enroll-application-dialog.component";
import {MatDialog} from '@angular/material';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-university-info',
  templateUrl: './college-info.component.html',
  styleUrls: ['./college-info.component.scss']
})
export class CollegeInfoComponent extends LangChange implements OnInit {

  colleges: College[];
  knowledgeFields: KnowledgeField[];
  knowledgeFieldList: KnowledgeField[];

  collegeInfoMap = new Map();
  langID: string;
  showInfo = false;
  params = {collegeId: 0, search: null, knowledgeFieldId: 0};

  constructor(private collegeInfoService: CollegeInfoService,
              _translateService: TranslateService,
              private _utils: Utils,
              private activatedRoute: ActivatedRoute,
              private dialog: MatDialog) {
    super(_translateService);
    this.langID = Language.getCurrentLanguage().code;
    const collegeId = this.activatedRoute.snapshot.queryParams['collegeId'];
    if (collegeId) {
      this.params.collegeId = Number.parseInt(collegeId);
      this.loadCollege();
    }
  }

  ngOnInit() {
    this.getColleges();
    this.getKnowledgeFields();
  }

  /**
   *  this class function get colleges list
   */
  getColleges() {
    this.collegeInfoService.getColleges(this.langID).subscribe(
      response => {
        this.colleges = response['dictionaryCollege'];
      },
      err => {
        console.log(err);
      }
    );
  }

  getKnowledgeFields() {
    this.collegeInfoService.getKnowledgeFields(this.langID).subscribe(
      response => {
        this.knowledgeFields = response['knowledgeFields'];
      },
      err => {
        console.log(err);
      }
    );
  }

  /**
   * when one of colleges is selected, function gives back some info
   */
  loadCollege() {
    this.showInfo = false;
    this.knowledgeFieldList = [];
    this.params.knowledgeFieldId = 0;
    if (this.params.collegeId) {
      this._utils.blockStart();
      this.collegeInfoService.getCollegeInfoByID(this.params.collegeId, this.langID).subscribe(
        data => {
          this.collegeInfoMap = data['collegeInfoMap'];
          if (this.collegeInfoMap['college_professions']) {
            const knowledgeFieldIDs = this.collegeInfoMap['college_professions'].map(e => e.knowledgeFieldID);
            this.knowledgeFields.filter(e => knowledgeFieldIDs.includes(e.id))
              .forEach(e => {
                this.knowledgeFieldList.push(e);
              });
            this.collegeInfoMap['professions_by_degree'] = [
              {
                id: '',
                name: this._translateService.instant('found'),
                itemList: this.collegeInfoMap['college_professions']
              }
            ];
          }
        },
        err => {
          console.log(err);
        },
        () => {
          this.showInfo = true;
          this._utils.blockStop();
        }
      );
    }
  }

  sendDocumentsToCollege(collegeInfoMap: any) {
    if (collegeInfoMap['reg_enroll_url']) {
      if (collegeInfoMap['reg_enroll_url'] === 'esuor_enroll_reg_url') {
        console.log('collegeInfoMap', collegeInfoMap)
        this.dialog.closeAll();
        const dialogRef = this.dialog.open(EnrollApplicationDialogComponent, {
          width: '900px',
          height: '650px',
          disableClose: true,
          data: {}
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            this._utils.notifySuccess(this._translateService.instant('saved'), null);
          }
        });
      } else {
        window.location.href = collegeInfoMap['reg_enroll_url'];
      }
    }
  }

  getKeys(map) {
    return Object.keys(map);
  }

  onLangChange(language): void {
    this.langID = language['code'];
    this.ngOnInit();
    this.params.collegeId = 0;
    this.showInfo = false;
  }
}

export class KnowledgeField {
  id: number;
  name: string;
}

export class CollegeProfession {
  knowledgeFieldID: number;
  knowledgeField: string;
  professionCode: string;
  professionName: string;
  specializationList: any[];
  isVisible: boolean;

  approvedBased9: number;
  approvedBased9KazakhLang: number;
  approvedBased11: number;
  approvedBased11KazakhLang: number;
  approvedBasedTiPo: number;
  approvedBasedTiPoKazakhLang: number;
}





// WEBPACK FOOTER //
// ./src/app/modules/common-main/components/college-info/college-info.component.ts